<template>
  <section>
    <div id="achievements" class="pd70 wbg">
      <UiBg class="bg" src="/static/image/video_bg2.jpg" />
      <div class="wrapper w1200">
        <UiAnim tag="h2" class="block_title">Наши достижения</UiAnim>

        <UiAnim class="achievements_box" :key="i" v-for="(it, i) in items">
          <img alt="" :src="`/static/image/icon/${it.icon}.png`" />
          <UiAnim tag="h3">{{ it.title }}</UiAnim>

          <UiAnim>
            <div
              class="achievements_value"
              v-for="(n, i2) in it.numbers"
              :key="i2"
            >
              <BlockAchNumbers :value="n" :pos="i2">
                <li>
                  <template v-if="i2 + 1 == it.numbers.length">0</template>
                </li>
                <li v-for="(v, i3) in n" :key="i3">{{ v }}</li>
              </BlockAchNumbers>
            </div>
            <span class="clr"></span>
          </UiAnim>
        </UiAnim>

        <span class="clr"></span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { inject } from "vue";
const achievements = inject("achievements");
const years = (new Date().getFullYear() - 2008 + "").split("");
years.forEach((y, i) => (years[i] = parseInt(y)));
const items = [
  {
    title: "Завершенных проектов",
    numbers: achievements.values[0],
    icon: "project",
  },
  {
    title: "Филиалов",
    numbers: achievements.values[1],
    icon: "buildings",
  },
  {
    title: "Лет успешной работы",
    numbers: years,
    icon: "timeline",
  },
];
</script>
